import axios from 'axios';
import {backendHost} from '../../config';

export const putChangeStatusLandings = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/landings/change-active`, params);
};